import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./AnimatedTextHighlight.css";

const AnimatedTextHighlight = ({
  text,
  backgroundImageUrl,
  speed = 120,
  fontSize = 32,
  lineBreakChar = "|",       // Default line break symbol
  loopPause = 1800,            // Longer pause at the end of a full loop
  spaceWidth = 20
}) => {

  const [highlightIndex, setHighlightIndex] = useState(0);
  const [restartNow, setRestartNow] = useState(false);

  // Flatten characters and track which are animatable (non-space, non-linebreak)
  const lines = text.split(lineBreakChar);
  const charArray = lines.join("").split("");
  const animatableIndexes = charArray
    .map((c, i) => (c !== " " ? i : null))
    .filter(i => i !== null);

  useEffect(() => {
    let timeoutId;

    if (highlightIndex === null || restartNow) {
      // After pause, restart from first index
      timeoutId = setTimeout(() => {
        setHighlightIndex(animatableIndexes[0]);
        setRestartNow(false); // reset
      }, restartNow ? 0 : loopPause);
    } else {
      const currentPos = animatableIndexes.indexOf(highlightIndex);
      const nextPos = currentPos + 1;

      if (nextPos >= animatableIndexes.length) {
        // Enlarge last character, then clear highlight
        timeoutId = setTimeout(() => {
          setHighlightIndex(null);
        }, speed); // Wait for animation to show
      } else {
        timeoutId = setTimeout(() => {
          setHighlightIndex(animatableIndexes[nextPos]);
        }, speed);
      }
    }

    return () => clearTimeout(timeoutId);
  }, [highlightIndex, speed, loopPause, restartNow, animatableIndexes]);

  return (
    <div className="text-wrapper" style={{ flexDirection: "column" }}
      onMouseEnter={() => setRestartNow(true)}
    >

      {lines.map((line, lineIndex) => (
        <div key={lineIndex} className="line-wrapper">
          {line.split("").map((char, index) => {

            const globalIndex = lines
              .slice(0, lineIndex)
              .reduce((acc, l) => acc + l.length, 0) + index;

            const isHighlighted = globalIndex === highlightIndex;
            const isSpace = char === " ";

            return (
              <motion.span
                key={globalIndex}
                className="char-block"
                animate={{
                  scaleY: isHighlighted ? 1.3 : 1.0,
                  scaleX: isHighlighted ? 1.3 : 1.0,
                }}
                transition={{ duration: 0.2 }}
                style={{
                  backgroundImage: char === " " ? "none" : `url(${backgroundImageUrl})`,
                  transformOrigin: "bottom",
                  fontSize: `${fontSize}px`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: isSpace ? `${spaceWidth}px` : undefined,
                }}
              >
                <p style={{ margin: 0, marginTop: "-3px", zIndex: 10 }}>{char}</p>
              </motion.span>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default AnimatedTextHighlight;



